import React from "react";

export function AdminHeader({ title, subtitle, actions }) {
  return (
    <div className="sticky top-0 z-20 bg-[#050505]/90 backdrop-blur-md border-b border-neutral-800 px-8 py-5">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div>
          <h1 className="font-heading text-2xl font-bold text-white tracking-tight">{title}</h1>
          {subtitle && <p className="text-sm text-neutral-500 mt-0.5">{subtitle}</p>}
        </div>
        <div className="flex items-center gap-2">{actions}</div>
      </div>
    </div>
  );
}

const STATUS_STYLES = {
  approved: "text-[#73bf44] bg-[#73bf44]/10 border-[#73bf44]/30",
  draft: "text-amber-400 bg-amber-500/10 border-amber-500/30",
  archived: "text-neutral-500 bg-neutral-800/60 border-neutral-700",
};

export function StatusBadge({ status }) {
  return (
    <span className={`text-[0.65rem] font-semibold px-2 py-0.5 rounded-full border capitalize ${STATUS_STYLES[status] || STATUS_STYLES.draft}`}>
      {status}
    </span>
  );
}

export function Dot({ on, label }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-xs">
      <span className={`w-2 h-2 rounded-full ${on ? "bg-[#73bf44]" : "bg-neutral-700"}`} />
      <span className={on ? "text-neutral-200" : "text-neutral-600"}>{label}</span>
    </span>
  );
}

export function LiveIndicator({ label = "Live" }) {
  return (
    <span
      title="Auto-refreshes every 15 seconds"
      data-testid="live-indicator"
      className="inline-flex items-center gap-1.5 text-[0.7rem] text-neutral-400 border border-neutral-800 rounded-full px-2.5 py-1"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-[#73bf44] pulse-dot" />
      {label}
    </span>
  );
}

export function PrimaryButton({ children, className = "", ...props }) {
  return (
    <button
      className={`inline-flex items-center gap-2 bg-[#73bf44] text-[#050505] rounded-full font-semibold px-5 py-2.5 text-sm hover:bg-[#5fa338] transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-[#73bf44] ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function GhostButton({ children, className = "", ...props }) {
  return (
    <button
      className={`inline-flex items-center gap-2 border border-neutral-700 text-neutral-200 rounded-full px-4 py-2.5 text-sm hover:border-neutral-500 hover:text-white transition-colors ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function Field({ label, children, hint }) {
  return (
    <div>
      <label className="text-sm text-neutral-400 mb-1.5 block">{label}</label>
      {children}
      {hint && <p className="text-xs text-neutral-600 mt-1">{hint}</p>}
    </div>
  );
}

export const inputCls =
  "w-full bg-black/40 border border-neutral-700 rounded-lg px-3 py-2.5 text-sm text-white outline-none focus:border-[#73bf44] transition-colors placeholder:text-neutral-600";
